var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlock = function SvgBlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.9998C6.47712 21.9998 2 17.5227 2 11.9999C2 6.47712 6.47712 2 11.9999 2C17.5227 2 21.9998 6.47712 21.9998 11.9999C21.9998 17.5227 17.5227 21.9998 11.9999 21.9998ZM18.4547 16.727C19.4262 15.4027 20 13.7684 20 12C20 7.58172 16.4183 4 12 4C10.2314 4 8.59679 4.57393 7.27234 5.54571L18.4547 16.727ZM16.9783 18.2627C15.612 19.3502 13.8819 20 12 20C7.58172 20 4 16.4183 4 12C4 10.1155 4.65163 8.38311 5.74185 7.01598L16.9783 18.2627Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/block.e7f3f43b.svg";
export { ForwardRef as ReactComponent };